import ImpactCard from "./ImpactCard";

interface FinancialImpactProps {
    measure: CarbonReductionMeasure;
}

interface ImpactCardsProps extends FinancialImpactProps {
    selected: "total" | "incremental";
}

function ImpactCards({ measure, selected }: ImpactCardsProps) {
    const simplePaybackValue = () => {
        if (selected === "total") {
            return measure.simplePaybackYearsTotal >= 0 ? measure.simplePaybackYearsTotal : Infinity;
        }
        return measure.simplePaybackYearsIncremental >= 0 ? measure.simplePaybackYearsIncremental : Infinity;
    };
    return (
        <div>
            <div className="small-cards">
                <ImpactCard
                    displayKey="netPresentValue"
                    value={selected === "total" ? measure.netPresentValueTotal : measure.netPresentValueIncremental}
                />
                <ImpactCard
                    displayKey="internalRateOfReturn"
                    value={
                        selected === "total"
                            ? measure.internalRateOfReturnTotal
                            : measure.internalRateOfReturnIncremental
                    }
                />
                <ImpactCard
                    displayKey="returnOnInvestment"
                    value={
                        selected === "total" ? measure.returnOnInvestmentTotal : measure.returnOnInvestmentIncremental
                    }
                />
                <ImpactCard displayKey="simplePayback" value={simplePaybackValue()} />
                <ImpactCard
                    displayKey="marginalAbatementCost"
                    value={
                        selected === "total"
                            ? measure.marginalAbatementCostTotal
                            : measure.marginalAbatementCostIncremental
                    }
                />
            </div>
        </div>
    );
}

export default ImpactCards;
